import axios from "axios";
import Datepicker from 'vuejs-datepicker';
import lodash from 'lodash';
import VueCkeditor from 'vue-ckeditor2';

const app = new Vue({
        el: '#app',
        components: {
            Datepicker,
            VueCkeditor
        },
        created: function () {
            this.debouncedSave = lodash.debounce(this.savePosting, 3000);
        },
        data: {
            copyFromPrivate: false,
            errors: [],
            posting: {
                applicationClosingDate: {},
                positionEndDate: {},
                positionStartDate: {},
                publicAddress: {},
                privateAddress: {},
                title: ''
            },
            token: null
        },
        methods: {
            checkForm: function (e) {
                this.errors = [];
                if (!app.posting.title) {
                    app.errors.push("A title is required");
                }
                if (!this.errors.length) {
                    return true;
                }

                e.preventDefault();

            },
            clearForm: function () {
                if (confirm("Are you sure you want to reset the form?")) {
                    app.posting = {
                        applicationClosingDate: {},
                        positionEndDate: {},
                        positionStartDate: {},
                        publicAddress: {},
                        privateAddress: {},
                        title: ''
                    };
                }
            },
            savePosting: function () {
                axios.post('/api/v1/job-posts/draft/save', app.posting);
            }
        },
        mounted() {
            axios
                .get('/api/v1/job-posts/draft')
                .then(response => {
                    let posting = response.data.posting;

                    if (!posting.applicationClosingDate) {
                        posting.applicationClosingDate = {date: null};
                    }
                    if (!posting.positionEndDate) {
                        posting.positionEndDate = {date: null};
                    }
                    if (!posting.positionStartDate) {
                        posting.positionStartDate = {date: null};
                    }
                    app.posting = posting;
                    app.token = response.data.token;
                })
        },
        watch: {
            posting: {
                handler: function (newPosting) {
                    this.debouncedSave();
                },
                deep: true
            },
            copyFromPrivate: function (newValue) {
                if (newValue) {
                    app.posting.publicAddress.firstName = app.posting.privateAddress.firstName;
                    app.posting.publicAddress.lastName = app.posting.privateAddress.lastName;
                    app.posting.publicAddress.phone = app.posting.privateAddress.phone;
                    app.posting.publicAddress.fax = app.posting.privateAddress.fax;
                    app.posting.publicAddress.email = app.posting.privateAddress.email;
                    app.posting.publicAddress.website = app.posting.privateAddress.website;
                    app.posting.publicAddress.address = app.posting.privateAddress.address;
                    app.posting.publicAddress.city = app.posting.privateAddress.city;
                    app.posting.publicAddress.province = app.posting.privateAddress.province;
                    app.posting.publicAddress.postalCode = app.posting.privateAddress.postalCode;
                } else {
                    app.posting.publicAddress.firstName = '';
                    app.posting.publicAddress.lastName = '';
                    app.posting.publicAddress.phone = '';
                    app.posting.publicAddress.fax = '';
                    app.posting.publicAddress.email = '';
                    app.posting.publicAddress.website = '';
                    app.posting.publicAddress.address = '';
                    app.posting.publicAddress.city = '';
                    app.posting.publicAddress.province = '';
                    app.posting.publicAddress.postalCode = '';
                }
            }
        }
    })
;
